export const SORT_OPTIONS = [
  { value: 'lotNumber', label: 'Lot Number' },
  { value: 'startingBid', label: 'Starting Bid' },
  { value: 'lowEstimate', label: 'Low Estimate' },
  { value: 'highEstimate', label: 'High Estimate' },
  { value: 'yourBid', label: 'Your Bid' },
  { value: 'category', label: 'Jewelry Type' },
  { value: 'isViewed', label: 'Viewed' },
  { value: 'isWatching', label: 'Watching' },
];

export const PERSONALIZED_FILTERS: {
  name: keyof HamptonTypes.PersonalizedFilters;
  label: string;
  icon: string;
}[] = [
  { name: 'watching', label: 'Watching', icon: 'watching' },
  { name: 'notViewed', label: 'Not viewed', icon: 'notViewed' },
];

export const bidIncrements: Array<[number[], number]> = [
  [[10, 99], 10],
  [[100, 499], 25],
  [[500, 999], 50],
  [[1000, 4999], 100],
  [[5000, 9999], 250],
  [[10000, 24999], 500],
  [[25000, 49999], 1000],
  [[50000, 1000000], 5000],
];

export const bidIncrementsTable: Array<[number[], number]> = [
  [[0, 99], 10],
  [[100, 499], 25],
  [[500, 999], 50],
  [[1000, 4999], 100],
  [[5000, 9999], 250],
  [[10000, 24999], 500],
  [[25000, 49999], 1000],
  [[50000, 0], 5000],
];
